import { useEffect, useState } from 'react'
import DateUtil from '../../util/DateUtil'

interface ChallengeStartsInProps {
  startDate: Date
  className?: string
}

export default function ChallengeStartsIn({ startDate, className }: ChallengeStartsInProps) {
  const [nowMs, setNowMs] = useState(() => Date.now())

  useEffect(() => {
    const interval = setInterval(() => setNowMs(Date.now()), 60_000)
    return () => clearInterval(interval)
  }, [])

  const label = DateUtil.formatStartsIn(startDate, nowMs)
  if (!label) return null

  return <span className={className}>{label}</span>
}
